export default __webpack_public_path__ + "static/media/Logo-dark.81388042.svg";